define('services/events/questionnaire-events',[
    // Libs
    'underscore', 'backbone', 'utils',
    // class
    'src/event-aggregator'

], function(
    // Libs
    _, Backbone, U,
    // class
    EventAggregator
) {

    var QuestionnaireEvents = _.extend({}, EventAggregator.prototype, {
        questionnaireSaved: function() {
            this.trigger('questionnaire:saved');
        },
    });

    return QuestionnaireEvents;

});

